import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core'
import { StateDescription } from '../../../../../../models/state-description'
import { concatMap, map, tap, catchError } from 'rxjs/operators'
import { EntityStateService } from '../../../../services/entity-state.service'
import { InlineEditCellDirective } from '../inline-edit-cell'
import { of } from 'rxjs'
import { StateMachine } from '../../../../../../models/state-machine'

@Component({
  selector: 'jml-lib-fsm-cell',
  templateUrl: './fsm-cell.component.html',
  styleUrls: ['../inline-edit-cell.scss']
})
export class FsmCellComponent extends InlineEditCellDirective implements OnChanges {
  @Input() entityType: string
  @Input() showLabel = true

  options = []

  noTransitionsAvailable = true

  constructor(private entityStateService: EntityStateService) {
    super()
  }

  ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes)
  }

  triggerEdit() {
    this.loadAvailableTransitions()
    this.originalContent = this.rowData[this.fieldName]

    requestAnimationFrame(() => {
      this.isEdited = true
    })
  }

  private loadAvailableTransitions() {
    const id = this.rowData['id']
    this.options = []
    this.noTransitionsAvailable = true

    this.entityStateService
      .getCurrentState(this.entityType, id)
      .pipe(
        tap((stateMachine) => {
          if (stateMachine.possibleTransitions && stateMachine.possibleTransitions.length > 0) {
            this.noTransitionsAvailable = false
            this.options = stateMachine.possibleTransitions.map((transition) => {
              return {
                label: transition.repr,
                value: transition
              }
            })
          }
        }),
        catchError((error) => {
          console.error('Error loading transitions:', error)
          return of(null)
        })
      )
      .subscribe()
  }

  onTransitionSelected(event) {
    this.isEdited = false
    const selectedTransition = event.value

    this.rowData[this.fieldName] = this.originalContent
    this.rowData[this.fieldName]['transitionId'] = selectedTransition['id']

    this.completeCellEdit.emit({
      data: this.rowData,
      field: this.fieldName
    })
  }
}
